// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main content grows to fill remaining space, pushing Footer to bottom */
#main-content {
  flex: 1 0 auto;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  background: #FFFFFF;
  color: #1F2937;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
}

.back-button:hover {
  background: #F9FAFB;
  border-color: #9CA3AF;
}

.back-button:focus-visible {
  outline: 2px solid #2563EB;
  outline-offset: 2px;
}

@media (max-width: 600px) {
  .back-button {
    min-height: 44px;
  }
}

/* Page-level Suspense fallback */
.page-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.page-loader-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E2E8F0;
  border-top-color: #C9A84C;
  border-radius: 50%;
  animation: page-spin 0.75s linear infinite;
}

@keyframes page-spin {
  to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Main content grows to fill remaining space, pushing Footer to bottom */\n#main-content {\n  flex: 1 0 auto;\n}\n\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 40px;\n  padding: 8px 14px;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  background: #FFFFFF;\n  color: #1F2937;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n\n.back-button:hover {\n  background: #F9FAFB;\n  border-color: #9CA3AF;\n}\n\n.back-button:focus-visible {\n  outline: 2px solid #2563EB;\n  outline-offset: 2px;\n}\n\n@media (max-width: 600px) {\n  .back-button {\n    min-height: 44px;\n  }\n}\n\n/* Page-level Suspense fallback */\n.page-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n}\n\n.page-loader-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #E2E8F0;\n  border-top-color: #C9A84C;\n  border-radius: 50%;\n  animation: page-spin 0.75s linear infinite;\n}\n\n@keyframes page-spin {\n  to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
